/**
 * Stripe client loader for the Beat Shop.
 * Publishable key is loaded the same way as other UI keys:
 *   process.env.REACT_APP_BEATSHOP_STRIPE_PUBLISHABLE_KEY
 * (from .env.development locally, or from Secret Manager React config in CI).
 * When absent (local mock PSP), PurchaseModal uses the labelled simulate step.
 */
import { loadStripe, Stripe } from '@stripe/stripe-js';

const publishableKey =
  process.env.REACT_APP_BEATSHOP_STRIPE_PUBLISHABLE_KEY ||
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ||
  '';

let stripePromise: Promise<Stripe | null> | null = null;

export const stripeConfigured = (): boolean => publishableKey.length > 0;

export const getStripe = (): Promise<Stripe | null> => {
  if (!stripePromise) {
    stripePromise = publishableKey
      ? loadStripe(publishableKey, {
          // Hide Stripe's sandbox testing assistant floating button.
          developerTools: {
            assistant: { enabled: false },
          },
        })
      : Promise.resolve(null);
  }
  return stripePromise as Promise<Stripe | null>;
};
